<div class="modal-inner">
    <h1>Tijd selecteren</h1>
    <div class="selectors">
        <div class="selector-box" [class.now-button]="showNowButton">
            <div class="time">:</div>
            @if (showNowButton) {
                <div class="currenttime" (click)="currentTime()" matRipple>NU</div>
            }
        </div>
        <div class="hours" (mousemove)="touchmove($event, 'hour')">
            @for (hour of hours; track hour) {
                <div
                    class="hour"
                    id="hour{{ hour.time }}"
                    [class.selected]="selectedhour == hour.time"
                    (click)="clickHour(hour.time)">
                    <small style="pointer-events: none">{{ hour.day }}&nbsp;</small>{{ hour.hour }}
                </div>
            }
        </div>
        <div class="minutes" (mousemove)="touchmove($event, 'minute')">
            @for (minute of minutes; track minute) {
                <div
                    class="minute"
                    id="minute{{ minute }}"
                    [class.selected]="selectedminute === minute"
                    (click)="clickMinute(minute)">
                    {{ minute }}
                </div>
            }
        </div>
        <div class="fader"></div>
    </div>

    <div class="buttons">
        <button class="planning-button confirm" (click)="selectAndClose()" mat-raised-button color="primary">
            Gereed
        </button>
        <button class="planning-button cancel" (click)="dialogRef.close()" mat-raised-button mat-dialog-close="">
            Annuleren
        </button>
    </div>
</div>
